/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Language_HeaderInputs */

const en_iconik_publish_language_header = /** @type {(inputs: Iconik_Publish_Language_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language Code`)
};

const fr_iconik_publish_language_header = /** @type {(inputs: Iconik_Publish_Language_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code langue`)
};

const de_iconik_publish_language_header = /** @type {(inputs: Iconik_Publish_Language_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachcode`)
};

const it_iconik_publish_language_header = /** @type {(inputs: Iconik_Publish_Language_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice della lingua`)
};

const ru_iconik_publish_language_header = /** @type {(inputs: Iconik_Publish_Language_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Языковой код`)
};

const es_iconik_publish_language_header = /** @type {(inputs: Iconik_Publish_Language_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de idioma`)
};

const zh_cn2_iconik_publish_language_header = /** @type {(inputs: Iconik_Publish_Language_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言代码`)
};

const ja_iconik_publish_language_header = /** @type {(inputs: Iconik_Publish_Language_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語コード`)
};

const hi_iconik_publish_language_header = /** @type {(inputs: Iconik_Publish_Language_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भाषा कोड`)
};

const pt_pt2_iconik_publish_language_header = /** @type {(inputs: Iconik_Publish_Language_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de idioma`)
};

/**
* | output |
* | --- |
* | "Language Code" |
*
* @param {Iconik_Publish_Language_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_language_header = /** @type {((inputs?: Iconik_Publish_Language_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Language_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_language_header(inputs)
	if (locale === "de") return de_iconik_publish_language_header(inputs)
	if (locale === "it") return it_iconik_publish_language_header(inputs)
	if (locale === "ru") return ru_iconik_publish_language_header(inputs)
	if (locale === "es") return es_iconik_publish_language_header(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_language_header(inputs)
	if (locale === "ja") return ja_iconik_publish_language_header(inputs)
	if (locale === "hi") return hi_iconik_publish_language_header(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_language_header(inputs)
	return en_iconik_publish_language_header(inputs)
});